module.exports = __webpack_public_path__ + "media/images/emblems/Fulenbach-blason-4fc5a7293826952b3d1320eb76149be2.png";